interface MenuApiUriData {
	data: string;
	currentPageId: string;
	home_url: string;
}
declare const menuApiUriData: MenuApiUriData;

export default {
	menuApiUriData,
};
